import { EventEmitter } from '@angular/core';
import { IClientDto } from '../../models/client.dto';

export abstract class EventEmitterContract {
  abstract selectClientSearchTableEmit: EventEmitter<IClientDto>;

  abstract selectClientSearchTable(selectedClient: IClientDto): void;
}
